import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Webmail() {
  const [doms, setDoms] = useState([]);

  const load = () => api.get('/domains').then(r => setDoms(r.data.filter(d => d.has_email)));
  useEffect(() => { load(); }, []);

  const enable = async (name) => {
    try { const r = await api.post('/email/webmail/enable', { domain: name }); alert(r.data.output); load(); }
    catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title"><h1>E-mail · Webmail</h1></div>
      <table>
        <thead><tr><th>Domínio</th><th>Status</th><th>URL</th><th></th></tr></thead>
        <tbody>
          {doms.map(d => (
            <tr key={d.id}>
              <td>{d.name}</td>
              <td>{d.has_webmail ? <span className="badge ok">habilitado</span> : <span className="badge warn">desabilitado</span>}</td>
              <td>{d.has_webmail ? <a href={`https://webmail.${d.name}`} target="_blank" rel="noreferrer">https://webmail.{d.name}</a> : '–'}</td>
              <td>{d.has_webmail
                ? <a href={`https://webmail.${d.name}`} target="_blank" rel="noreferrer"><button className="secondary">Abrir</button></a>
                : <button onClick={() => enable(d.name)}>Ativar</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
